<template>
	<div class="news-detail">
		<div class="rs-d-surf-container">
			<div v-if="detailData.title" class="detail-header">
				<div class="detail-title">{{ detailData.title }}</div>
				<div v-if="detailData.time" class="detail-date">{{ detailData.time }}</div>
			</div>
			<div v-if="detailData.title" class="detail-cover">
				<el-image :src="getCoverPicture(detailData)" fit="cover" class="cover-image" />
			</div>
			<div v-if="detailData.content" class="detail-content jm-editor" v-html="detailData.content"></div>
		</div>
	</div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useRoute } from '@/utils/vue-api';
import dayjs from 'dayjs';
import { useModuleDefaultCover } from '@rebuild/hooks/comp/useModuleDefaultCover';
import { useModuleData } from '@rebuild/hooks/data/useModuleData';

const route = useRoute();
const { getDefaultCover } = useModuleDefaultCover();
const getCoverPicture = item => {
	return item.image || getDefaultCover('news');
};

const id = ref('');
const detailData = ref({});

const { news_detail } = useModuleData();
const getNewsDetail = async () => {
	await news_detail.refresh({ id: id.value });
	const resData = news_detail.data?.data;
	detailData.value = {
		...resData,
		time: resData.time ? dayjs(resData.time).format('YYYY.MM.DD') : ''
	};
};

onMounted(() => {
	id.value = route.query.id;
	if (id.value) {
		getNewsDetail();
	}
});
</script>

<style lang="less" scoped>
.news-detail {
	padding-top: 60px;
	padding-bottom: 20px;
	min-height: 100vh;

	.detail-header {
		margin-bottom: 20px;
		display: flex;
		flex-direction: column;
		gap: 8px;

		.detail-title {
			color: var(--surf-inverse-color);
			font-size: 16px;
			font-weight: 500;
			line-height: 24px;
			word-break: break-word;
		}

		.detail-date {
			color: rgba(var(--surf-inverse-color-rgb), 0.7);
			font-size: 14px;
			font-weight: 400;
			line-height: 18px;
		}
	}

	.detail-cover {
		margin-bottom: 20px;
		border-radius: 12px;
		height: 336px;
		overflow: hidden;

		.cover-image {
			width: 100%;
			height: 100%;
		}
	}

	.detail-content {
		color: rgba(var(--surf-inverse-color-rgb), 0.4);
		font-size: 14px;
		font-weight: 400;
		line-height: 18px;
		word-break: break-word;
	}
}
</style>
